<template>
  <div v-show="panelShow">
    <Col :xs="24" :sm="24" :md="12" :lg="colSpanBig" :style="{padding: '5px'}">
      <Card shadow style="height: 330px;" class="home-card">
        <div slot="title"><Icon type="md-checkbox-outline" /><b> 持续交付待办</b></div>
        <Alert type="warning" show-icon v-if="error" class="cicd-upcoming-alart-warning">获取待办数据失败</Alert>
        <Spin fix v-else-if="loading" class="home-component-loading">
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div>加载中</div>
        </Spin>
        <Alert type="success" show-icon v-else-if="!eventList.length" class="cicd-upcoming-alert-success">
          <span>当前无待办</span>
        </Alert>
        <GeminiScrollbar class="logs-scroll-bar cicd-upcoming-logs-scroll-bar" :style="{height: '250px'}" v-else>
          <div style="margin-right: 10px; padding-right: 5px">
            <div style="padding-bottom: 5px" v-for="item in eventList" :key="'cicd_key_' + item.id">
              <span style="float: left">{{ item.title }}</span>
              <router-link :to="{ name: item.url, query: { id: item.id }}"><a style="float: right">前往</a></router-link>
              <br>
            </div>
          </div>
        </GeminiScrollbar>
      </Card>
    </Col>
  </div>
</template>

<script>
import { getDeployUpcomingList } from '@/api/idc'

export default {
  name: 'ci-cd-upcoming',
  props: {
    panelShow: {
      type: Boolean,
      default: true
    },
    colSpanBig: {
      type: Number,
      default: 8
    }
  },
  data () {
    return {
      eventList: [],
      error: false,
      loading: true
    }
  },
  watch: {
    panelShow () {
      if (this.panelShow) {
        this.getData()
      }
    }
  },
  created: function () {
    if (this.panelShow) {
      this.getData()
    }
  },
  methods: {
    getData () {
      this.loading = true
      getDeployUpcomingList().then(res => {
        this.loading = false
        this.eventList = res.data
      }).catch(res => {
        this.error = true
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
  .cicd-upcoming-alart-warning {
    background-color: rgba(244, 114, 11, 0.6);
    border: unset;
    color: #fff
  }
  .cicd-upcoming-alert-success {
    background-color: rgba(0, 255, 0, 0.5);
    border: unset;
    color: #fff;
  }
  .cicd-upcoming-loading {
    background-color: rgba(30,28,29, 0.9);
  }
</style>
<style>
  .cicd-upcoming-logs-scroll-bar .-vertical {
    background-color: rgba(255, 255, 255, 0.05);
  }
  .cicd-upcoming-logs-scroll-bar .gm-scrollbar .thumb {
    background-color: rgba(255, 255, 255, 0.6);
  }
</style>
